import React from "react";
import constants from "./constants";

const SegmentControl = ({ options, selectedOption, onChange }) => {
  return (
    <div className="flex flex-row">
      {options.map((option, index) => {
        let specialClasses;
        if (index === 0) {
          specialClasses = "rounded-l-md";
        } else if (index === options.length - 1) {
          specialClasses = "rounded-r-md";
        } else {
          specialClasses = "";
        }

        return (
          <div
            key={option.value}
            className={`cursor-pointer px-3 py-1 ${specialClasses} ${
              option.value === selectedOption.value
                ? `bg-${constants.primaryColorClass} text-white`
                : "bg-gray-200 bg-${constants.primaryColorClass}"
            }`}
            onClick={() => onChange(option)}
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

export default SegmentControl;
